import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { ChatScreen } from "../components";
import { RecipientHeader } from "../components/chat";

export const Chat = () => {
  return (
    <ContentLayout title="Chat" header={<RecipientHeader />} showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
          >
            <ChatScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
